//import cat from "../assets/cat.jpg" // Tell webpack this JS file uses this image
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>ไม่พบหน้า</title>
        <meta name="description" content="Not Found" />
      </Helmet>

      <div className="d-flex justify-content-center vw-100 vh-100 align-items-center flex-col">
        <div className="text-center w-75">
          <h1 className="text-danger">ไม่พบหน้า</h1>
          <h2 className="mt-3">ขออภัยด้วย ไม่พบหน้าที่คุณกำลังตามหา!</h2>
        </div>
      </div>
    </>
  );
}
